export function relativeTime(iso) {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  const diff = Math.max(0, Date.now() - then);
  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}

export function absoluteTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", timeZone: "UTC" }) + " UTC";
}

export function minutesUntil(iso) {
  if (!iso) return null;
  return Math.round((new Date(iso).getTime() - Date.now()) / 60000);
}

export function kickoffLabel(iso) {
  const m = minutesUntil(iso);
  if (m == null) return "";
  if (m <= 0) return "in progress";
  if (m < 60) return `${m}m to first pitch/tip`;
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m to game`;
}


// "Returns in X days" countdown from an ESPN estimated return date (YYYY-MM-DD or ISO).
export function returnCountdown(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  const days = Math.round((d.setHours(0, 0, 0, 0) - today.setHours(0, 0, 0, 0)) / 86400000);
  const date = new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
  if (days < 0) return { days, label: `Est. return was ${date}`, soon: false, past: true };
  if (days === 0) return { days, label: "Est. return today", soon: true, past: false };
  if (days === 1) return { days, label: "Returns in 1 day", soon: true, past: false };
  return { days, label: `Returns in ${days} days`, soon: days <= 7, past: false, date };
}
